import Grid from '@mui/material/Grid';
import { type SxProps, styled, type Theme } from '@mui/material/styles';

import type { JSX } from 'react';

const StyledContainerGrid = styled(Grid)`
  background: ${({ theme }) => theme.palette.background.boxLight};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  margin: 0 -24px;
  padding: ${({ theme }) => theme.spacing(1.5, 3)};
  width: auto;
`;

interface DrawerTopBoxProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  gap?: number;
}

export const DrawerTopBox = ({ children, sx, gap }: DrawerTopBoxProps): JSX.Element => {
  return (
    <StyledContainerGrid container sx={[{ gap }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </StyledContainerGrid>
  );
};
